
export enum 在庫数区分型 {
    在庫あり = '在庫あり',
    在庫なし = '在庫なし',
    マイナス在庫 = 'マイナス在庫',
}

export enum 商品区分型 {
    医薬品 = '医薬品',
    その他品 = 'その他品',
}
